<!-- Header -->
<div mat-dialog-title>
  <span translate>Register New Family</span>
</div>

<!-- Body -->
<mat-dialog-content>
	<div translate>
		This option is intended for use by families who are <b translate>new</b> to the district.
	</div>
	<div style="padding-top:15px;"
		translate>
		This means none of the students in the family are currently attending any of the schools in the district and none of the students have attended any of the schools in the district in the past.
  </div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

	<!-- Left -->
	<div class="flex-footer-left" *ngIf="enableSelfRegistrationCode">
    <button type="button" class="btn btn-link" style="padding-bottom: 10px;" (click)="alreadyHaveCodeClick()"
    aria-label="Already have a code?" translate> Already have a code?
</button>
  </div>

	<!-- Right -->
	<div class="flex-footer-right">
		<tyl-button image="previous arrow.png" label="Previous" (clickEvent)="modalInstancePreviousClick()"></tyl-button>
		<tyl-button image="next arrow yellow.png" label="Next" (clickEvent)="modalInstanceNextClick()"></tyl-button>
		<tyl-button image="Cancel.png" label="Cancel" (clickEvent)="modalInstanceCancelClick()"></tyl-button>
	</div>
</mat-dialog-actions>

<!-- Old Code -->
<!--<div class="popup">-->
  <!--<div class="modal-header">-->
    <!--<div class="modal-headerTitle" style="padding-left:10px;padding-top:10px;" translate>Register New Family</div>-->
  <!--</div>-->
  <!--<div style="padding:10px;margin-bottom:70px;">-->
    <!--<div [innerHTML]="'This option is intended for use by families who are <b>new</b> to the district.' | translate"></div>-->
    <!--<div style="padding-top:15px;" translate>-->
      <!--This means none of the students in the family are currently attending any of the schools in the district and none of the students have attended any of the schools in the district in the past.-->
    <!--</div>-->
  <!--</div>-->
  <!--<div class="sis-app-footer">-->
      <!--<div class="footerRight">-->
        <!--<tyl-button image="previous arrow.png" label="Previous" (clickEvent)="modalInstancePreviousClick()"></tyl-button>-->
        <!--<tyl-button image="next arrow yellow.png" label="Next" (clickEvent)="modalInstanceNextClick()"></tyl-button>-->
        <!--<tyl-button image="Cancel.png" label="Cancel" (clickEvent)="modalInstanceCancelClick()"></tyl-button>-->
      <!--</div>-->
  <!--</div>-->
<!--</div>-->
